import React from 'react';
import { Star } from 'lucide-react';
import '../styles/Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Marie-Claude Dubois",
      location: "Sherbrooke",
      initials: "MD",
      service: "Fertilisation de pelouse",
      rating: 5,
      text: "Notre pelouse n'a jamais été aussi belle ! Après seulement deux traitements de fertilisation, le gazon est devenu dense et d'un vert éclatant. L'équipe est professionnelle et très à l'écoute. Je recommande sans hésiter !"
    },
    {
      name: "Jean-François Lavoie",
      location: "Magog",
      initials: "JL",
      service: "Taille de haie",
      rating: 5,
      text: "Excellent travail de taille de haie ! Nos cèdres sont parfaitement droits et uniformes. Le service est rapide, propre et le prix est très raisonnable. On fait affaire avec eux chaque année maintenant."
    },
    {
      name: "Sophie Tremblay",
      location: "Granby",
      initials: "ST",
      service: "Contrôle de mauvaises herbes",
      rating: 5,
      text: "On avait un gros problème de pissenlits et de mauvaises herbes. Après le traitement de Naturellement Vert, notre terrain est redevenu impeccable. Merci pour le travail remarquable !"
    },
    {
      name: "Patrick Bergeron",
      location: "Drummondville",
      initials: "PB",
      service: "Fertilisation de pelouse",
      rating: 5,
      text: "Service impeccable du début à la fin. L'équipe a pris le temps de bien évaluer notre terrain et de nous proposer un programme adapté. Les résultats parlent d'eux-mêmes. Bravo !"
    },
    {
      name: "Isabelle Côté",
      location: "Sherbrooke",
      initials: "IC",
      service: "Taille de haie & Fertilisation",
      rating: 5,
      text: "Nous avons fait appel à Naturellement Vert pour la taille de nos haies et la fertilisation. Le résultat est spectaculaire ! Nos voisins nous demandent maintenant qui s'occupe de notre terrain."
    },
    {
      name: "Martin Gagnon",
      location: "Coaticook",
      initials: "MG",
      service: "Fertilisation de pelouse",
      rating: 5,
      text: "Très bon service, ponctuel et professionnel. Notre pelouse est en bien meilleure santé depuis qu'on fait affaire avec eux. Le rapport qualité-prix est excellent pour la région."
    }
  ];

  return (
    <section className="testimonials-section section">
      <div className="container">
        <div className="section-header text-center">
          <p className="contact-subtitle">TÉMOIGNAGES</p>
          <h2 className="display-medium">Ce que nos clients disent</h2>
          <div className="title-underline"></div>
          <p className="body-large" style={{maxWidth: '700px', margin: '0 auto'}}>
            La satisfaction de nos clients est notre plus grande fierté.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card nvf-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  {testimonial.initials}
                </div>
                <div className="testimonial-meta">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-location">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="#ECFF25" stroke="#ECFF25" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.text}"</p>
              
              <div className="testimonial-service">{testimonial.service}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
